import ContactList from './ContactList';
import ContactShow from './ContactShow';
import ContactEdit from './ContactEdit';
import ContactCreate from './ContactCreate';
import Icon from '@material-ui/icons/PermPhoneMsg';

const ops = {
    list: ContactList,
    show: ContactShow,
    edit: ContactEdit,
    create: ContactCreate,
    icon: Icon
};

export default ops;
